(function (angular) {
  "use strict";

  var m = angular.module("app");

  m.directive("pcmMessages", ["Messages", "_", function (Messages, _) {

    var templateString =
      "<div id=\"messages\">" +
      "<div class=\"alert alert-{{ message.type }}\" ng-repeat=\"message in messages\">" +
      "<a class=\"close\" ng-click=\"closeMessage(message)\" data-dismiss=\"alert\">&times;</a>" +
      "<span ng-bind-html=\"message.message | unsafe\"></span>" +
      "</div>" +
      "</div>";

    return {
      restrict: "E",
      template: templateString,
      scope: {},
      controller: ["$scope", function ($scope) {
        var messages = Messages.getMessages();

        for (var i = 0; i < messages.length; i++) {
          messages[i].read = true;
        }
        $scope.messages = messages;

        $scope.closeMessage = function (message) {
          message.closed = true;
          var index = $scope.messages.indexOf(message);
          $scope.messages.splice(index, 1);
        };

        $scope.$watchCollection(function () {
          return Messages.getMessages();
        }, function (messages) {
          for (var j = 0; j < messages.length; j++) {
            messages[j].read = true;
          }
          $scope.messages = messages;
        });

      }],
      link: function (scope, element, attrs) {

      }
    };
  }]);

  m.directive("pcmSubmit", ["$parse", function ($parse) {
    return {
      restrict: "A",
      require: ["form"],
      link: function (scope, element, attrs, controllers) {
        var formController = controllers[0];
        var fn = $parse(attrs.pcmSubmit);
        var submitIfFn;

        if (attrs.pcmSubmitIf) {
          submitIfFn = $parse(attrs.pcmSubmitIf);
        }

        formController.shouldSubmit = function (event) {
          if (typeof submitIfFn === "function" && submitIfFn(scope, {
              $event: event
            }) === false) {
            return false;
          }

          return true;
        };

        formController.needsAttention = function (field) {
          return field.$invalid && formController.submitted;
        };

        formController.setSubmitted = function (val) {
          formController.submitted = val;
          if (!scope.$$phase) scope.$apply();
        }

        function safeApply(scope, fn) {
          (scope.$$phase || scope.$root.$$phase) ? fn(): scope.$apply(fn);
        }

        element.bind("submit", function (event) {
          if (formController.shouldSubmit(event) === false) {
            return;
          }

          formController.setSubmitted(true);

          if (!scope.$$phase) scope.$apply();

          if (!formController.$valid) return false;

          safeApply(scope, function () {
            formController.setSubmitted(false);
            fn(scope, {
              $event: event
            });
          });
        });
      }
    };
  }]);

})(window.angular);



// WEBPACK FOOTER //
// ./app/components/messages.directive.js